// extracted by css-extract-rspack-plugin
export default {"Anchor":"yLfXG"};